import React, { useState } from 'react';

const TagInput = ({ tags = [], setTags, placeholder = 'Enter a tag...', validationRegex }) => {
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState('');

  const handleAddTag = () => {
    const newTag = inputValue.trim();

    if (newTag) {
      if (validationRegex && !validationRegex.test(newTag)) {
        setError('Invalid tag format.');
      } else if (!tags.includes(newTag)) {
        setTags([...tags, newTag]);
        setError('');
      }
    }

    setInputValue('');
  };

  const handleRemoveTag = (tag) => {
    setTags(tags.filter((t) => t !== tag));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="d-flex flex-wrap gap-2 p-2 border rounded-md">
        {tags?.map((tag, index) => (
          <div key={index} className="btn btn-sm flex items-center bg-primary text-white px-2 py-1 rounded-full">
            {tag}
            <button
              className="text-white bg-transparent border-0 outline-0"
              onClick={() => handleRemoveTag(tag)}
            >
              ✕
            </button>
          </div>
        ))}

        <input
          type="text"
          className="form-control"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
        />
      </div>

      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  );
};

export default TagInput;
